<div class="page-header">
  <screen-toolbar [showBackButton]="false">
  </screen-toolbar>

</div>

<div class="subscription_prices_container relative pt-8 pb-12 sm:pt-20 sm:pb-24 px-6 sm:px-16 overflow-hidden">
  <!-- Background - @formatter:off -->
  <svg class="-z-1 absolute inset-0" viewBox="0 0 960 540" width="100%" height="100%"
    preserveAspectRatio="xMidYMax slice" xmlns="http://www.w3.org/2000/svg">
    <g class="opacity-40 text-gray-200 dark:text-gray-800" fill="none" stroke="currentColor" stroke-width="100">
      <circle r="234" cx="196" cy="23"></circle>
      <circle r="234" cx="790" cy="491"></circle>
    </g>
  </svg>
  <!-- @formatter:on -->

  <!-- Header with animated bold title -->
  <div class="subscription_prices_header">
    <h2 class="text-xl font-bold animate__animated animate__fadeIn">{{ 'SUBSCRIPTION_SETTINGS.PRICING' | translate }}
    </h2>

    <!-- Add marketplace description -->
    <div class="marketplace-description mt-4">
      {{ 'SUBSCRIPTION_SETTINGS.MARKETPLACE_DESCRIPTION' | translate }}
    </div>

    <!-- Request Custom Quote Button -->
    <div class="custom-quote-button-container mt-4">
      <button mat-raised-button color="accent" (click)="openQuoteRequestDialog()">
        {{ 'SUBSCRIPTION_SETTINGS.send_cotation' | translate }}
      </button>
    </div>

    <!-- Alerts Section -->
    <ng-container *ngIf="subscribedPackages.length > 0">
      <div class="alert alert-info text-center">
        <h3 class="mb-3 font-bold">{{ "PAYABLE_INVOICE.VIEW.YOU_SUBSCRIBED" | translate }}:</h3>
        <ul class="list-disc inline-block text-left mb-3">
          <li *ngFor="let package of subscribedPackages; let i = index" class="mb-1">
            {{package.name}}
          </li>
        </ul>
        <div class="text-center mt-3">
          <button *ngIf="!edit" mat-flat-button
            style="margin: 0 10px; background-color: var(--mat-theme-primary-color); color: white"
            (click)="enableEdit()">
            {{ "SUBSCRIPTION_SETTINGS.EDIT_MY_SUBSCRIPTION" | translate }}
          </button>
          <button *ngIf="edit" mat-flat-button style="margin: 0 10px;background-color: #e44891;color: white"
            (click)="enableEdit()">
            {{"SUBSCRIPTION_SETTINGS.CANCEL_EDIT" | translate}}
          </button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="subscribedPackages.length === 0 && currentUser.isFreeTrial">
      <div class="alert warning-info">
        {{ "PAYABLE_INVOICE.VIEW.YOUR_TRIAL_END" | translate }}:
        <span>{{currentUser.remainingDay}}</span>
      </div>
    </ng-container>

    <ng-container *ngIf="subscriptionsRequests.length > 0">
      <div class="alert alert-info">
        {{ "PAYABLE_INVOICE.VIEW.REQUEST_SENT_STATUS" | translate }}
        {{ '{' }}
        <span *ngFor="let request of subscriptionsRequests; let i = index">
          {{request?.subscriptionPackage?.name}}:
          {{"DASHBOARD.STATUS_CODE."+getStatus(subscriptionsRequestsStatus)| translate}}{{i !==
          subscriptionsRequests.length - 1 ? ', ' : ''}}
        </span>
        {{ '}' }}
      </div>
    </ng-container>
  </div>

  <!-- Cards Section with enhanced borders -->
  <div class="package_cards_section cardWithShadow">
    <div class="row" style="width: 100%; justify-content: center">
      <div class="col-12 col-sm-6 col-md-6 col-lg-4" *ngFor="let subscriptionPackage of subscriptionPackages"
        style="margin-bottom: 1rem; padding: 0.5rem">
        <div class="package_price_card enhanced-border" [ngClass]="{'usedPackage': subscriptionPackage.isUsed}">
          <!-- Ribbon for subscribed packages -->
          <div *ngIf="subscriptionPackage.isUsed" class="ribbon ribbon-top-left">
            <span>{{ 'SUBSCRIPTION_SETTINGS.SUBSCRIBED' | translate }}</span>
          </div>

          <!-- Ribbon for pending/under approval packages -->
          <div *ngIf="subscriptionPackage?.isPending" class="ribbon ribbon-top-left pending-ribbon">
            <span>{{ 'SUBSCRIPTION_SETTINGS.PENDING' | translate }}</span>
          </div>

          <!-- Package Name & Description -->
          <div class="Package_name">{{ subscriptionPackage.name }}</div>

          <!-- Package Type Label -->
          <div class="package-type-label">
            <span *ngIf="subscriptionPackage?.isRequiredQuotation" class="quotation-required">
              {{ 'SUBSCRIPTION_SETTINGS.QUOTATION_REQUIRED' | translate }}
            </span>
            <span *ngIf="subscriptionPackage?.isCustomPackage && !subscriptionPackage?.isRequiredQuotation"
              class="can-customize">
              {{ 'SUBSCRIPTION_SETTINGS.CAN_CUSTOMIZE' | translate }}
            </span>
            <span *ngIf="!subscriptionPackage?.isRequiredQuotation && !subscriptionPackage?.isCustomPackage"
              class="standard">
              {{ 'SUBSCRIPTION_SETTINGS.STANDARD' | translate }}
            </span>
          </div>

          <div class="Package_desc">
            <ng-container *ngIf="subscriptionPackage.description">
              {{ (subscriptionPackage.description.length > 120 ? (subscriptionPackage.description | truncate:[120,
              '...']) : subscriptionPackage.description ) }}
              <span *ngIf="subscriptionPackage.description.length > 120" class="more_btn"
                (click)="openMore(subscriptionPackage.description)"
                [style.right]="_translate?.currentLang === 'ar' ? 'auto' : '10px'"
                [style.left]="_translate?.currentLang === 'en' ? 'auto' : '10px'">
                more
              </span>
            </ng-container>
          </div>

          <!-- Billing Period Toggle -->
          <div class="toggle-group-container">
            <mat-button-toggle-group [hideSingleSelectionIndicator]="true"
              (change)="onChangePeriod($event,subscriptionPackage)" [value]="SUB_PERIODS[0].value">
              <mat-button-toggle *ngFor="let period of SUB_PERIODS" [value]="period.value">
                {{ period.bundleCode | translate }}
              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>

          <!-- Price Calculation Section - removed rounded-shape div -->
          <div class="price_container">
            <!-- Original Price -->
            <div>
              <ng-container [ngSwitch]="subscriptionPackage.id">
                <!-- Limit Package -->
                <ng-container *ngSwitchCase="2">
                  <ng-container [ngSwitch]="limitPeriodId">
                    <div *ngSwitchCase="2" class="price-dir">
                      <span class="price price-before">{{ subscriptionPackage.price }} SR</span>
                      <small>{{ 'SUBSCRIPTION_SETTINGS.PRICE_BEFORE' | translate }}</small>
                    </div>
                    <div *ngSwitchCase="3" class="price-dir">
                      <span class="price price-before">{{ subscriptionPackage.price * 3 }} SR</span>
                      <small>{{ 'SUBSCRIPTION_SETTINGS.PRICE_BEFORE' | translate }}</small>
                    </div>
                    <div *ngSwitchCase="4" class="price-dir">
                      <span class="price price-before">{{ subscriptionPackage.price * 6 }} SR</span>
                      <small>{{ 'SUBSCRIPTION_SETTINGS.PRICE_BEFORE' | translate }}</small>
                    </div>
                    <div *ngSwitchCase="5" class="price-dir">
                      <span class="price price-before">{{ subscriptionPackage.price * 12 }} SR</span>
                      <small>{{ 'SUBSCRIPTION_SETTINGS.PRICE_BEFORE' | translate }}</small>
                    </div>
                  </ng-container>
                </ng-container>

                <!-- Base Package -->
                <ng-container *ngSwitchCase="3">
                  <ng-container [ngSwitch]="basePeriodId">
                    <div *ngSwitchCase="2" class="price-dir">
                      <span class="price price-before">{{ subscriptionPackage.price }} SR</span>
                      <small>{{ 'SUBSCRIPTION_SETTINGS.PRICE_BEFORE' | translate }}</small>
                    </div>
                    <div *ngSwitchCase="3" class="price-dir">
                      <span class="price price-before">{{ subscriptionPackage.price * 3 }} SR</span>
                      <small>{{ 'SUBSCRIPTION_SETTINGS.PRICE_BEFORE' | translate }}</small>
                    </div>
                    <div *ngSwitchCase="4" class="price-dir">
                      <span class="price price-before">{{ subscriptionPackage.price * 6 }} SR</span>
                      <small>{{ 'SUBSCRIPTION_SETTINGS.PRICE_BEFORE' | translate }}</small>
                    </div>
                    <div *ngSwitchCase="5" class="price-dir">
                      <span class="price price-before">{{ subscriptionPackage.price * 12 }} SR</span>
                      <small>{{ 'SUBSCRIPTION_SETTINGS.PRICE_BEFORE' | translate }}</small>
                    </div>
                  </ng-container>
                </ng-container>

                <!-- ERB Package -->
                <ng-container *ngSwitchCase="4">
                  <ng-container [ngSwitch]="erbPeriodId">
                    <div *ngSwitchCase="2" class="price-dir">
                      <span class="price price-before">{{ subscriptionPackage.price }} SR</span>
                      <small>{{ 'SUBSCRIPTION_SETTINGS.PRICE_BEFORE' | translate }}</small>
                    </div>
                    <div *ngSwitchCase="3" class="price-dir">
                      <span class="price price-before">{{ subscriptionPackage.price * 3 }} SR</span>
                      <small>{{ 'SUBSCRIPTION_SETTINGS.PRICE_BEFORE' | translate }}</small>
                    </div>
                    <div *ngSwitchCase="4" class="price-dir">
                      <span class="price price-before">{{ subscriptionPackage.price * 6 }} SR</span>
                      <small>{{ 'SUBSCRIPTION_SETTINGS.PRICE_BEFORE' | translate }}</small>
                    </div>
                    <div *ngSwitchCase="5" class="price-dir">
                      <span class="price price-before">{{ subscriptionPackage.price * 12 }} SR</span>
                      <small>{{ 'SUBSCRIPTION_SETTINGS.PRICE_BEFORE' | translate }}</small>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </div>

            <!-- Discounted Price -->
            <div>
              <ng-container [ngSwitch]="subscriptionPackage.id">
                <!-- Limit Package -->
                <ng-container *ngSwitchCase="2">
                  <ng-container [ngSwitch]="limitPeriodId">
                    <div *ngSwitchCase="2" class="price-dir">
                      <span class="price">{{ subscriptionPackage.price - (subscriptionPackage.price * (limitDiscount /
                        100)) }} SR</span>
                      <small>{{ 'SUBSCRIPTION_SETTINGS.PRICE_AFTER' | translate }}</small>
                    </div>
                    <div *ngSwitchCase="3" class="price-dir">
                      <span class="price">{{ (subscriptionPackage.price * 3) - ((subscriptionPackage.price * 3) *
                        (limitDiscount / 100)) }} SR</span>
                      <small>{{ 'SUBSCRIPTION_SETTINGS.PRICE_AFTER' | translate }}</small>
                    </div>
                    <div *ngSwitchCase="4" class="price-dir">
                      <span class="price">{{ (subscriptionPackage.price * 6) - ((subscriptionPackage.price * 6) *
                        (limitDiscount / 100)) }} SR</span>
                      <small>{{ 'SUBSCRIPTION_SETTINGS.PRICE_AFTER' | translate }}</small>
                    </div>
                    <div *ngSwitchCase="5" class="price-dir">
                      <span class="price">{{ (subscriptionPackage.price * 12) - ((subscriptionPackage.price * 12) *
                        (limitDiscount / 100)) }} SR</span>
                      <small>{{ 'SUBSCRIPTION_SETTINGS.PRICE_AFTER' | translate }}</small>
                    </div>
                  </ng-container>
                </ng-container>

                <!-- Base Package -->
                <ng-container *ngSwitchCase="3">
                  <ng-container [ngSwitch]="basePeriodId">
                    <div *ngSwitchCase="2" class="price-dir">
                      <span class="price">{{ subscriptionPackage.price - (subscriptionPackage.price * (baseDiscount /
                        100)) }} SR</span>
                      <small>{{ 'SUBSCRIPTION_SETTINGS.PRICE_AFTER' | translate }}</small>
                    </div>
                    <div *ngSwitchCase="3" class="price-dir">
                      <span class="price">{{ (subscriptionPackage.price * 3) - ((subscriptionPackage.price * 3) *
                        (baseDiscount / 100)) }} SR</span>
                      <small>{{ 'SUBSCRIPTION_SETTINGS.PRICE_AFTER' | translate }}</small>
                    </div>
                    <div *ngSwitchCase="4" class="price-dir">
                      <span class="price">{{ (subscriptionPackage.price * 6) - ((subscriptionPackage.price * 6) *
                        (baseDiscount / 100)) }} SR</span>
                      <small>{{ 'SUBSCRIPTION_SETTINGS.PRICE_AFTER' | translate }}</small>
                    </div>
                    <div *ngSwitchCase="5" class="price-dir">
                      <span class="price">{{ (subscriptionPackage.price * 12) - ((subscriptionPackage.price * 12) *
                        (baseDiscount / 100)) }} SR</span>
                      <small>{{ 'SUBSCRIPTION_SETTINGS.PRICE_AFTER' | translate }}</small>
                    </div>
                  </ng-container>
                </ng-container>

                <!-- ERB Package -->
                <ng-container *ngSwitchCase="4">
                  <ng-container [ngSwitch]="erbPeriodId">
                    <div *ngSwitchCase="2" class="price-dir">
                      <span class="price">{{ subscriptionPackage.price - (subscriptionPackage.price * (erbDiscount /
                        100)) }} SR</span>
                      <small>{{ 'SUBSCRIPTION_SETTINGS.PRICE_AFTER' | translate }}</small>
                    </div>
                    <div *ngSwitchCase="3" class="price-dir">
                      <span class="price">{{ (subscriptionPackage.price * 3) - ((subscriptionPackage.price * 3) *
                        (erbDiscount / 100)) }} SR</span>
                      <small>{{ 'SUBSCRIPTION_SETTINGS.PRICE_AFTER' | translate }}</small>
                    </div>
                    <div *ngSwitchCase="4" class="price-dir">
                      <span class="price">{{ (subscriptionPackage.price * 6) - ((subscriptionPackage.price * 6) *
                        (erbDiscount / 100)) }} SR</span>
                      <small>{{ 'SUBSCRIPTION_SETTINGS.PRICE_AFTER' | translate }}</small>
                    </div>
                    <div *ngSwitchCase="5" class="price-dir">
                      <span class="price">{{ (subscriptionPackage.price * 12) - ((subscriptionPackage.price * 12) *
                        (erbDiscount / 100)) }} SR</span>
                      <small>{{ 'SUBSCRIPTION_SETTINGS.PRICE_AFTER' | translate }}</small>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </div>
          </div>

          <!-- Action Buttons -->
          <!-- Request Quote Button for packages that require quotation - only show if not subscribed -->
          <button *ngIf="subscriptionPackage?.isRequiredQuotation && !subscriptionPackage.isUsed"
            (click)="openQuoteRequestDialog(subscriptionPackage.name)" mat-stroked-button color="primary"
            class="submit-button">
            {{ 'SUBSCRIPTION_SETTINGS.request_cotation' | translate }}
          </button>

          <ng-container *ngIf="edit">
            <!-- Get started button for unselected packages -->
            <button
              *ngIf="!subscriptionPackage?.isPending && !isSelected(subscriptionPackage?.billingPackageId) && !subscriptionPackage?.isRequiredQuotation"
              (click)="choosePackage(subscriptionPackage.billingPackageId)" class="basic" mat-stroked-button>
              {{'SUBSCRIPTION_SETTINGS.GET_STARTED' | translate }}
            </button>

            <!-- Button for selected packages -->
            <div *ngIf="!subscriptionPackage?.isPending && isSelected(subscriptionPackage?.billingPackageId)"
              class="selected-package-actions">
              <!-- Show cancel subscription button if package is subscribed (works for both regular and quotation-required packages) -->
              <button *ngIf="subscriptionPackage.isUsed" (click)="choosePackage(subscriptionPackage.billingPackageId)"
                class="red-hover black-text w-100" mat-stroked-button>
                {{ 'SUBSCRIPTION_SETTINGS.CANCEL_SUBSCRIPTION' | translate }}
                <img src="assets/images/icons/cross.svg" alt="">
              </button>

              <!-- Show this for newly selected packages -->
              <div *ngIf="!subscriptionPackage.isUsed" class="d-flex justify-content-between w-100 gap-2">
                <button class="basic-hover w-100" mat-stroked-button disabled>
                  {{ 'SUBSCRIPTION_SETTINGS.SELECTED' | translate }}
                  <img src="assets/images/icons/round-check.svg" alt="">
                </button>
                <!-- <button class="unselect-button" 
                  (click)="unselectPackage(subscriptionPackage.billingPackageId)">
                  <mat-icon >clear</mat-icon>
                </button> -->
                <div>
                  <mat-icon class="unselect-button"
                    (click)="unselectPackage(subscriptionPackage.billingPackageId)">close</mat-icon>

                </div>

              </div>
            </div>
          </ng-container>

          <!-- Custom Package Options - Only show for selected packages with isCustomPackage=true -->
          <!-- Removing the full package option checkbox -->

          <!-- Features Accordion -->
          <div class="features">
            <div class="features_title-container d-flex justify-content-between align-items-center w-100">
              <div class="features_title d-flex align-items-center">
                {{ 'SUBSCRIPTION_SETTINGS.CORE_FEATURES' | translate }}
                <mat-icon class="expandable-hint ml-1">keyboard_arrow_down</mat-icon>
              </div>
              <button
                *ngIf="edit && isSelected(subscriptionPackage?.billingPackageId) && subscriptionPackage.isCustomPackage && !subscriptionPackage.isUsed"
                mat-button color="primary" class="select-all-button" (click)="toggleFullPackage()">
                {{ isFull ? 'SUBSCRIPTION_SETTINGS.DESELECT_ALL' : 'SUBSCRIPTION_SETTINGS.SELECT_ALL' | translate }}
              </button>
            </div>
            <mat-accordion>
              <mat-expansion-panel *ngFor="let module of subscriptionPackage.userModule" hideToggle
                class="example-headers-align">
                <mat-expansion-panel-header>
                  <mat-panel-title style="font-size: 14px;" (click)="expandAllScreens(module)">
                    <!-- Only show checkboxes if package is not already subscribed -->
                    <mat-checkbox
                      *ngIf="edit && isSelected(subscriptionPackage?.billingPackageId) && subscriptionPackage.isCustomPackage && !subscriptionPackage.isUsed"
                      [checked]="isModuleSelected(module.id) || isFull" [disabled]="isFull"
                      (change)="toggleModuleSelection(module)" (click)="$event.stopPropagation()" color="primary">
                    </mat-checkbox>
                    <mat-icon>{{ module.fontIcon }}</mat-icon>
                    <p>{{ module.name }}</p>
                    <!-- Add arrow icon to indicate expandability -->
                    <mat-icon class="expand-arrow ml-auto">keyboard_arrow_down</mat-icon>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <!-- Screen with nested transactions -->
                <div *ngFor="let screen of module.screens" class="screens">
                  <!-- Make screen expandable with explicit (click) handler -->
                  <div class="screen-header" [class.no-transactions]="!screen.hasTransactions"
                    [class.clickable]="screen.hasTransactions" (click)="toggleScreen(screen)">
                    <mat-icon>{{ screen.fontIcon || 'desktop_windows' }}</mat-icon>
                    <p>{{ screen.name }}</p>
                    <!-- Only show expand icon if screen has transactions -->
                    <mat-icon *ngIf="screen.hasTransactions" class="expand-icon" [class.rotated]="screen.expanded">
                      keyboard_arrow_down
                    </mat-icon>
                  </div>

                  <!-- Transactions container - only shown if screen has transactions and is expanded -->
                  <div class="transactions-container" *ngIf="screen.expanded && screen.hasTransactions">
                    <div *ngFor="let transaction of screen.transactions" class="transaction-item"
                      [matTooltip]="transaction.details | translate" matTooltipPosition="above">
                      <mat-icon>{{ transaction.fontIcon }}</mat-icon>
                      <p>{{ transaction.name | translate }}</p>
                    </div>
                  </div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>

        </div>
      </div>
    </div>
  </div>

  <!-- Submit Button with Selected Packages Count -->
  <div class="fixed-button-container"
    *ngIf="edit && (!arraysEqualIgnoreOrder(baseSelectedPackages, selectedPackages) || isCustomPackage) && selectedPackages.length"
    [ngClass]="_translate?.currentLang === 'ar' ? 'fixed-button-container-ar' : 'fixed-button-container-en'">

    <button (click)="submitPackagesSelection()" mat-raised-button color="primary" class="pulseBtn"
      [matTooltip]="getSelectedPackagesTooltip()" matTooltipPosition="above">
      {{ 'COMMON.SUBMIT_SELECTION' | translate }}
      <div class="package-count-badge" *ngIf="getPackagesToConfirmCount() > 0">{{ getPackagesToConfirmCount() }}</div>
      <mat-icon>task_alt</mat-icon>
    </button>
  </div>
</div>